import { Pipe, PipeTransform } from '@angular/core';
import { ColorTranslatableSchema } from '@app/schemas/color';

@Pipe({
  name: 'colorTranslate',
})
export class ColorTranslatePipe implements PipeTransform {

  public transform(color: ColorTranslatableSchema | null | undefined, lang: string | 'fallback'): string | undefined {
    if (!color) {
      return undefined;
    }

    if (lang === 'fallback') {
      return color.translations[color.fallback];
    }

    return color.translations[lang] || color.translations[color.fallback];
  }

}
